export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_lmj-services/artifacts/34li2a6s_7088.png?v=3";

export const COMPANY = {
    name: "LMJ International, LLC",
    short: "LMJ International",
    phone: "307.317.7797",
    phoneTel: "+13073177797",
    email: "clientservices@lmjintl.com",
    address: {
        line1: "30 North Gould Street, #64034",
        line2: "Sheridan, WY 82801",
        full: "30 North Gould Street, #64034, Sheridan, WY 82801",
    },
    tagline: "NAVSEA Certified Welding & Marine Industrial Services",
};

export const SERVICES = [
    {
        slug: "navsea",
        title: "NAVSEA Certified Welding",
        short: "Naval-grade welding to Navy yard procedures.",
        description:
            "Certified to the rigorous standards of Naval Sea Systems Command. Cleared welders qualified across Navy yard procedures for surface combatants, submarines, and auxiliary vessels.",
        bullets: [
            "Submarine-safe procedures",
            "Surface combatant fabrication",
            "Yard-certified processes",
            "MIL-STD compliance",
        ],
    },
    {
        slug: "submarine-ship",
        title: "Submarine & Ship Welding",
        short: "Pressure-hull, piping, and structural work.",
        description:
            "From pressure-hull work to deck repairs, we deploy crews experienced with the tight tolerances and access constraints of submarine and surface ship welding.",
        bullets: [
            "Hull patch & insert",
            "Tank & void repair",
            "Topside structural",
            "Confined-space qualified",
        ],
    },
    {
        slug: "pipe",
        title: "Pipe Welding & Fitting",
        short: "Including CuNi and Navy yard procedures.",
        description:
            "Journeyman pipe welders and fitters certified on all required yard procedures, including copper-nickel (CuNi). Spool fabrication, in-place repair, and pressure systems.",
        bullets: [
            "CuNi capability",
            "Stainless / carbon / alloy",
            "Spool fab & install",
            "Hydro & pressure-test support",
        ],
    },
    {
        slug: "structural",
        title: "Structural Welding & Fitting",
        short: "ABS-certified structural welders & fitters.",
        description:
            "Heavy structural welding and fitting backed by ABS certification. From foundations and bulkheads to keel-up assemblies and major reworks.",
        bullets: [
            "ABS Certified",
            "Layout & fit-up",
            "Heavy plate",
            "Code-compliant joints",
        ],
    },
    {
        slug: "mig-tig",
        title: "MIG / TIG / Flux Core / Stick",
        short: "Multi-process welders incl. aluminum.",
        description:
            "Our journeymen carry the full process toolkit: MIG, TIG, flux-core, and stick — with aluminum availability for non-ferrous work.",
        bullets: [
            "Aluminum availability",
            "Carbon & stainless",
            "Procedure-qualified",
            "Continuous on-the-job certification",
        ],
    },
    {
        slug: "mobile",
        title: "On-Site & Mobile Crews",
        short: "Deployable crews to any U.S. shipyard.",
        description:
            "Temporary labor crews mobilized to any U.S. shipyard or industrial site. We handle the paperwork, travel, and compliance so crews arrive ready to work.",
        bullets: [
            "Rapid mobilization",
            "Nationwide deployment",
            "Full compliance handled",
            "Travel coordinated",
        ],
    },
    {
        slug: "fabrication",
        title: "Fabrication Support",
        short: "Machinist, millwright, scaffolding, rigging.",
        description:
            "Beyond welding: machinist/millwright, scaffolders, and riggers experienced in shipyard operations support every phase of the build.",
        bullets: [
            "Teardown / rebuild / maintenance",
            "Shipyard scaffolding",
            "Shipyard rigging",
            "Machinist & millwright support",
        ],
    },
];

export const STATS = [
    { value: "NAVSEA", label: "Certified" },
    { value: "ABS", label: "Certified" },
    { value: "MIL-SPEC", label: "Compliant" },
    { value: "24/7", label: "Mobilization" },
];

export const IMAGES = {
    heroSparks: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&w=2400&q=80",
    structural: "https://images.unsplash.com/photo-1455165814004-1126a7199f9b?auto=format&fit=crop&w=2000&q=80",
    pipe: "https://images.pexels.com/photos/27354192/pexels-photo-27354192.jpeg?auto=compress&cs=tinysrgb&w=2000",
    pipeline: "https://images.pexels.com/photos/27354189/pexels-photo-27354189.jpeg?auto=compress&cs=tinysrgb&w=2000",
};

export const PHOTOS = [
    {
        type: "video",
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/3bfaa92161b80f00_VID_20261013_192944.mp4",
        alt: "Shop walkthrough — pipe & flange fabrication",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/91807ff33df05572_IMG_20261013_192953.webp",
        alt: "Submarine hull section — in-process onboard work",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/f43b58152a031afd_IMG_20261013_193001.webp",
        alt: "Large pressure cylinder on transport cradle",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/f57ff6a2763bbe55_IMG_20261013_193007.webp",
        alt: "Heavy-haul transport — pressure vessel delivery",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/06321efce2a3e171_IMG_20261013_193013.webp",
        alt: "LMJ supervisor inspecting heavy plate assembly",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/4a492eecade41947_IMG_20261013_193020.webp",
        alt: "Shop walk-through — angled plate structure",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/779e4355b45211c1_IMG_20261013_193032.webp",
        alt: "Interior pipe bore — root pass weld inspection",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/5c181ec84b32fcf6_IMG_20261013_193038.webp",
        alt: "LMJ pipe welder on the yard floor",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/ca8a3e74f2475c92_IMG_20261013_193045.webp",
        alt: "Shipboard deck plating — onboard work",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/d8b4dada395758b5_IMG_20261013_193051.webp",
        alt: "Confined-space weld prep — insulated bulkhead",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/8f81d70e096040da_IMG_20261013_193056.webp",
        alt: "Heat-shielded worksite — in-service repair",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/dc5b15a33976ac93_IMG_20261013_192940.webp",
        alt: "Large welded steel enclosure — structural assembly",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/e8bc93309b6ae26e_IMG_20261013_192935.webp",
        alt: "CuNi pipe spool with flanged elbows",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/098cce8579e55cda_IMG_20261013_192923.webp",
        alt: "Reducer-to-flange weld with heat-tint colors",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/33ab74584f4a9bf4_IMG_20261013_192916.webp",
        alt: "Structural steel assembly in fabrication shop",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/8064f677fd38dfa2_IMG_20261013_192908.webp",
        alt: "Pipe spool run on roller stands",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/17fa52d325409d7f_IMG_20261013_192905.webp",
        alt: "Pipe insert weld — detail",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/3d45af7e4be12296_IMG_20261013_192903.webp",
        alt: "Heavy pipe insert into structural saddle",
    },
    {
        src: "https://customer-assets-jt897jd0.emergentagent.net/job_lmj-services/artifacts/b08b5988894ed3f4_IMG_20261013_192901.webp",
        alt: "Pipe-to-saddle insert weld — fabrication shop",
    },
];
